import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  align?: 'left' | 'center';
}
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'center'
}: SectionHeaderProps) {
  const wrap = align === 'center' ? 'mx-auto text-center items-center' : 'text-left items-start';
  const lead = align === 'center' ? 'mx-auto' : '';
  return <div className={`flex max-w-3xl flex-col ${wrap}`} data-id="element-519">
      {eyebrow && <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent" data-id="element-520">
          {eyebrow}
        </div>}
      <h2 className="mt-4 font-serif-display text-5xl leading-[1.0] tracking-tight text-white sm:text-6xl" data-id="element-521">
        {title}
      </h2>
      {subtitle && <p className={`mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg ${lead}`} data-id="element-522">
          {subtitle}
        </p>}
    </div>;
}